{
  "clock_in": "Clock In",
  "clock_out": "Clock Out",
  "clock_in_now": "Clock in now",
  "clock_in_with_comment": "Clock in with comment",
  "clocked_in_prefix": "Clocked in",
  "click_to_clock_out": "Click to clock out",
  "comment_placeholder": "Add a comment (optional)...",
  "permissions_module_title": "Time tracking module",
  "permissions_module_description": "Access to clock in and clock out",
  "permissions_entries_title": "Time tracking entries",
  "permissions_entries_description": "View and edit employee time tracking entries",
  "time_tracking": "Time Tracking",
  "timesheets": "Timesheets",
  "adjust_time": "Adjust time",
  "view_profile": "View profile",
  "started": "Started",
  "finished": "Finished",
  "original": "Original",
  "this_week": "This week",
  "click_to_adjust": "Click to adjust time",
  "no_entries": "No entries",
  "active": "Active",
  "active_session_since": "Active session since {date}",
  "active_session": "Active session",
  "delete_entry": "Delete entry",
  "delete_entry_confirm": "Delete this time entry?",
  "create_entry": "Create entry",
  "edit_entry": "Edit entry",
  "edit_reason": "Reason for edit",
  "clock_in_comment": "Clock-in comment",
  "clock_out_comment": "Clock-out comment",
  "edit_reason_placeholder": "Reason for edit (optional)...",
  "date": "Date",
  "scope_active": "Active employees",
  "scope_with_entries": "Employees with entries",
  "scope_all": "All employees",
  "export_summary": "Summary report",
  "export_detailed": "Detailed report"
}
